<app-popin [popinTitle]="'data_sources.add'"
           [loader]="dataSourcesLoading$ | async"
           contentHighlightID="content-popin-add-data-source">
           title-class="p-side-1rem"
           class="blue-bg"
           helpTemplate="add-data-source">
  <div content *ngIf="(allList$ | async).length">
    <div>
      <app-input
        appearance="outline"
        type="text"
        icon="search"
        [control]="searchText"
        [label]="'data_sources.search' | translate"></app-input>
    </div>
    <div *ngIf="(multipleList$ | async | listFilter:this.searchText.value).length > 0">
      <h3>{{ 'data_sources.create_many_sources' | translate }}</h3>
      <div class="data-sources-listing">
        <app-data-card *ngFor="let dataSource of multipleList$ | async | listFilter:this.searchText.value"
                       [datasource]="dataSource"
                       (click)="openModal(dataSource)"></app-data-card>
      </div>
    </div>
    <div *ngIf="(allList$ | async | listFilter:this.searchText.value).length > 0; else elseBlock">
      <h3 *ngIf="(topList$ | async | listFilter:this.searchText.value).length > 0">
        {{ 'data_sources.most_popular' | translate }}
      </h3>
      <div class="data-sources-listing">
        <app-data-card *ngFor="let dataSource of topList$ | async | listFilter:this.searchText.value"
                       [datasource]="dataSource"
                       (click)="openModal(dataSource)"></app-data-card>
      </div>
      <div *ngFor="let dataSourceGroup of groupedList$ | async">
        <h3 *ngIf="dataSourceGroup.showGroup !== 0 && (dataSourceGroup.dataSources | listFilter:this.searchText.value).length > 0">
          {{ dataSourceGroup.name }}
        </h3>
        <div class="data-sources-listing">
          <app-data-card *ngFor="let dataSource of dataSourceGroup.dataSources | listFilter:this.searchText.value"
                         [datasource]="dataSource"
                         (click)="openModal(dataSource)">
          </app-data-card>
        </div>
      </div>
    </div>
    <ng-template #elseBlock>
      <!-- Todo: Make it work-->
      <div class="data-sources-listing">
        <app-data-card *ngFor="let dataSource of notFoundList$ | async"
                       [datasource]="dataSource"
                       (click)="openIframe.openDialog({inputData: { link: this.dataSourcesS.getSetupLink(dataSource) } })"></app-data-card>
      </div>
    </ng-template>
  </div>
</app-popin>
<app-dialog #openIframe [config]="dialogOpenIframeConfig"></app-dialog>
